import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
const { useDocumentWidth } = Hooks;
const {getUrl} = Util;
import Iconblock from "@/assets/images/academy/iconblock.png";
import Bright from "@/assets/images/academy/bright.png";
import Blockr from "@/assets/images/academy/blockr.png";
import Blockhover from "@/assets/images/academy/blockhover.png";

import Block1 from "@/assets/images/academy/block1.png";
import Block2 from "@/assets/images/academy/block2.png";
import Block3 from "@/assets/images/academy/block3.png";
import Block4 from "@/assets/images/academy/block4.png";
import Block5 from "@/assets/images/academy/block5.png";
import Block6 from "@/assets/images/academy/block6.png";
import Block7 from "@/assets/images/academy/block7.png";
import Block8 from "@/assets/images/academy/block8.png";
import Block9 from "@/assets/images/academy/block9.png";

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  const isMobile = (useDocumentWidth() ?? 0) <= 768;

  return (
    <div className={cx(styles.blockchain, className)}>
      <div className={cx(styles.blockcontent, className)}>
        <h2>Blockchain Technology</h2>
        <h5> Blockchain Technology is truly the backbone when it comes to cryptocurrencies, NFT’s, the Metaverse, and much more. </h5>
        <div className={cx(styles.contentmore, className)}>
          <a href={getUrl("/academy/learn-blockchain")}>
            <p>Learn more</p>
            {isMobile ? ">>" : <img src={Iconblock} />}
          </a>
        </div>
        <ul>
          <li>
            <div>
              <a href={getUrl("/academy/learn-blockchain#blockchain1")}>
                <img src={Block1} />
                <h4>So how do these blocks work?</h4>
                {isMobile ?<img className={cx(styles.iconrigsts, className)} src={Blockr} /> : <img className={cx(styles.iconright, className)} src={Bright} />}
                
              </a>
            </div>
            <div>
              <a href={getUrl("/academy/learn-blockchain#blockchain4")}>
                <img src={Block2} />
                <h4>What problems does blockchain solve?</h4>
                {isMobile ?<img className={cx(styles.iconrigsts, className)} src={Blockr} /> : <img className={cx(styles.iconright, className)} src={Bright} />}
              </a>
            </div>
            <div>
              <a href={getUrl("/academy/learn-blockchain#blockchain7")}>
                <img src={Block3} />
                <h4>Proof of Work (PoW)</h4>
                {isMobile ?<img className={cx(styles.iconrigsts, className)} src={Blockr} /> : <img className={cx(styles.iconright, className)} src={Bright} />}
              </a>
            </div>
          </li>
          <li>
            <div>
              <a href={getUrl("/academy/learn-blockchain#blockchain2")}>
                <img src={Block4} />
                <h4>Now that we know that, how does the blockchain system work?</h4>
                {isMobile ?<img className={cx(styles.iconrigsts, className)} src={Blockr} /> : <img className={cx(styles.iconright, className)} src={Bright} />}
              </a>
            </div>
            <div>
              <a href={getUrl("/academy/learn-blockchain#blockchain5")}>
                <img src={Block5} />
                <h4>Peer-to-peer (P2P)</h4>
                {isMobile ?<img className={cx(styles.iconrigsts, className)} src={Blockr} /> : <img className={cx(styles.iconright, className)} src={Bright} />}
              </a>
            </div>
            <div>
              <a href={getUrl("/academy/learn-blockchain#blockchain8")}>
                <img src={Block6} />
                <h4>Proof of Stake (PoS)</h4>
                {isMobile ?<img className={cx(styles.iconrigsts, className)} src={Blockr} /> : <img className={cx(styles.iconright, className)} src={Bright} />}
              </a>
            </div>
          </li>
          <li>
            <div>
              <a href={getUrl("/academy/learn-blockchain#blockchain3")}>
                <img src={Block7} />
                <h4>Is Blockchain Safe?</h4>
                {isMobile ?<img className={cx(styles.iconrigsts, className)} src={Blockr} /> : <img className={cx(styles.iconright, className)} src={Bright} />}
              </a>
            </div>
            <div>
              <a href={getUrl("/academy/learn-blockchain#blockchain6")}>
                <img src={Block8} />
                <h4>Blockchain Mining</h4>
                {isMobile ?<img className={cx(styles.iconrigsts, className)} src={Blockr} /> : <img className={cx(styles.iconright, className)} src={Bright} />}
              </a>
            </div>
            <div>
              <a href={getUrl("/academy/learn-blockchain#blockchain9")}>
                <img src={Block9} />
                <h4>Where to for Blockchain?</h4>
                {isMobile ?<img className={cx(styles.iconrigsts, className)} src={Blockr} /> : <img className={cx(styles.iconright, className)} src={Bright} />}
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default observer(Main);
// export default Main;
